"use strict";
exports.__esModule = true;
function update(newState) {
    exports.state = newState;
}
exports.update = update;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSG9vay9zdG9yZS9zdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBLGdCQUF1QixRQUFhO0lBQ2xDLGFBQUssR0FBRyxRQUFRLENBQUE7QUFDbEIsQ0FBQztBQUZELHdCQUVDIn0=